import React from 'react'
import Button from './Button'
import Input from './Input'
import Select from './Select'
import { Accordion, Badge, Card, EmptyState, InlineAlert, MappingEditorShell, PageHeader, Skeleton, Status } from './ui'

export default function FoundationPage () {
  return (
    <main className='ui-foundation'>
      <PageHeader title='UI Foundation' description='Компоненты нового интерфейса Connector Hub' />
      <div className='ui-foundation__grid'>
        <Card>
          <h2>Действия</h2>
          <div className='ui-foundation__actions' role='group' aria-label='Примеры действий'>
            <Button>Основное действие</Button>
            <Button variant='stroke'>Вторичное</Button>
          </div>
        </Card>
        <Card><h2>Поля</h2><Input aria-label='Название сценария' placeholder='Название' /><br /><Select aria-label='Статус'><option>Черновик</option></Select></Card>
        <Card><h2>Статусы</h2><Badge>Черновик</Badge> <Status tone='success'>Активен</Status><br /><br /><InlineAlert tone='warning' title='Нужно действие'>Переподключите источник</InlineAlert></Card>
        <Card><h2>Состояния</h2><Skeleton aria-label='Загрузка примера' /><br /><EmptyState title='Пока пусто' description='Здесь появятся сценарии' /></Card>
        <Card><h2>Аккордеон</h2><Accordion title='Подробнее'>Содержимое секции</Accordion></Card>
        <Card><h2>Сопоставление</h2><MappingEditorShell source={<Input aria-label='Источник' value='STAGE_ID' readOnly />} target={<Select aria-label='Назначение'><option>Статус</option></Select>} /></Card>
      </div>
    </main>
  )
}
